import { BREAK_TYPES_LONG } from '../definitions';

function convertSecondsToHHMM(seconds) {
  return new Date(seconds * 1000).toISOString().substr(11, 5);
}

function convertHHMMToSeconds(timeString) {
  const split = timeString.split(':');
  return 3600 * split[0] + 60 * split[1];
}

function getTimeDiff(start, end, mealBreak) {
  if (!start || !end) {
    return 0;
  }
  let diffSeconds = convertHHMMToSeconds(end) - convertHHMMToSeconds(start);

  if (diffSeconds < 0) {
    diffSeconds += 24 * 3600;
  }
  if (mealBreak) {
    diffSeconds -= convertHHMMToSeconds(mealBreak);
    if (diffSeconds < 0) {
      diffSeconds = 0;
    }
  }
  return parseFloat(parseFloat(diffSeconds / 60 / 60).toFixed(2));
}

function calculateAgreedHoursDetailsShiftPaidHours(startTime, endTime, breaks) {
  const unpaidBreaks = [BREAK_TYPES_LONG.MEAL];
  if (!startTime || !endTime) {
    return 0;
  }
  let diffSeconds =
    convertHHMMToSeconds(endTime) - convertHHMMToSeconds(startTime);

  if (diffSeconds < 0) {
    diffSeconds += 24 * 3600;
  }

  if (breaks.length > 0) {
    const calculateUnpaidBreaksTime = breaks.reduce((total, shiftBreak) => {
      if (
        unpaidBreaks.includes(shiftBreak.breakType) &&
        shiftBreak.breakDuration !== null &&
        shiftBreak.breakDuration !== ''
      ) {
        return total + convertHHMMToSeconds(shiftBreak.breakDuration);
      }
      return total;
    }, 0);
    diffSeconds -= calculateUnpaidBreaksTime;
    if (diffSeconds < 0) {
      diffSeconds = 0;
    }
  }
  return parseFloat(parseFloat(diffSeconds / 60 / 60).toFixed(2));
}

function roundTime(time, minutesToRound = 15) {
  let [hours, minutes] = time.split(':');
  hours = parseInt(hours);
  minutes = parseInt(minutes);

  // Convert hours and minutes to time in minutes
  const timeInMinutes = hours * 60 + minutes;

  const rounded = Math.round(timeInMinutes / minutesToRound) * minutesToRound;
  const rHr = '' + Math.floor(rounded / 60);
  const rMin = '' + (rounded % 60);

  const result = rHr.padStart(2, '0') + ':' + rMin.padStart(2, '0');

  return result === '24:00' ? '00:00' : result;
}

function convertTimestampToPhpISO8601(intTimestamp) {
  let date = new Date();
  date.setTime(intTimestamp);

  let strISO8601 = '';
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();
  let hour = date.getHours();
  let minute = date.getMinutes();
  let second = date.getSeconds();
  let timezone = (date.getTimezoneOffset() / 60) * -1;

  const sanitise = num => (num < 10 ? `0${num}` : num);

  month = sanitise(month);
  day = sanitise(day);
  hour = sanitise(hour);
  minute = sanitise(minute);
  second = sanitise(second);

  if (timezone > 0) {
    timezone = '+' + timezone;
  }

  strISO8601 = `${year}-${month}-${day}T${hour}:${minute}:${second}${timezone}:00`;

  return strISO8601;
}

export {
  convertSecondsToHHMM,
  convertHHMMToSeconds,
  getTimeDiff,
  calculateAgreedHoursDetailsShiftPaidHours,
  roundTime,
  convertTimestampToPhpISO8601,
};
